export const EXTENSION_RESOURCE = 'EXTENSION_RESOURCE';
export const PAGE = 'PAGE';